import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const NewsDateAndProvider = styled.p`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.mediumGray};
  margin-bottom: ${({ theme }) => theme.x1space}rem;
  ${media.lgUp`
    margin-bottom: ${({ theme }) => theme.x2space}rem;
  `}
`;

export const NewsTitle = styled(Button)`
  ${({ theme }) => theme.typography.baseStrong}
  ${media.lgUp`
    margin-right: ${({ theme }) => theme.x3space}rem;
  `}
`;
